module.exports = __webpack_public_path__ + "8da74c37fe03638c2f2642a4fd777dbe.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image8.png
 ** module id = 286
 ** module chunks = 0
 **/